(function () {
  var root = document.documentElement;

  function initReveal(scope) {
    if (!('IntersectionObserver' in window)) return;
    root.classList.add('xa-js');
    if (!window.__xaIO) {
      window.__xaIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            window.__xaIO.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    (scope || document).querySelectorAll('.xa-io:not(.is-in), .xa-io-clip:not(.is-in)').forEach(function (el) {
      window.__xaIO.observe(el);
    });
  }

  function initExplorer(scope) {
    (scope || document).querySelectorAll('[data-xa-explorer]').forEach(function (box) {
      if (box.__xaReady) return;
      box.__xaReady = true;
      var buttons = box.querySelectorAll('.xa-sc');
      var images = box.querySelectorAll('.xa-stack img');
      var notes = box.querySelector('[data-xa-notes]');
      var price = box.querySelector('[data-xa-price]');
      var idInput = box.querySelector('input[name="id"]');
      var addBtn = box.querySelector('[data-xa-add]');
      var details = box.querySelector('[data-xa-details]');
      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () {
          buttons.forEach(function (x, j) {
            x.classList.toggle('is-on', j === i);
            x.setAttribute('aria-pressed', j === i ? 'true' : 'false');
          });
          images.forEach(function (img, j) { img.classList.toggle('is-on', j === i); });
          if (notes) notes.textContent = b.dataset.notes || '';
          if (price && b.dataset.price) price.textContent = b.dataset.price;
          if (details && b.dataset.url) details.setAttribute('href', b.dataset.url);
          if (idInput && b.dataset.variant) {
            idInput.value = b.dataset.variant;
            if (addBtn) addBtn.disabled = b.dataset.available === 'false';
          }
        });
      });
    });
  }

  function init(scope) {
    initReveal(scope);
    initExplorer(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-run when a section is added or changed
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    e.target.querySelectorAll('.xa-io, .xa-io-clip').forEach(function (el) { el.classList.add('is-in'); });
  });
})();


(function () { var last = null, lastIdx = 0, cache = {}, token = 0; function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); } function images(h) { if (!cache[h]) cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) { return p.images || []; }); return cache[h]; } function cur() { var g = document.querySelector('media-gallery'); if (!g) return null; var li = g.querySelector('li.is-active[data-media-id]') || g.querySelector('li[data-media-id]'); return li && li.querySelector('img'); } function swap() { if (!last) return; var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return; var s = slug(last); var my = ++token; images(m[1]).then(function (list) { var url = list.filter(function (u) { return u.split('/').pop().split('?')[0].indexOf(s) !== -1; })[0]; if (!url) return; var img = cur(); if (!img || my !== token) return; if ((img.currentSrc || img.src).indexOf(s) !== -1) { img.style.opacity = '1'; return; } var j = url.indexOf('?') === -1 ? '?' : '&'; var src = url + j + 'width=1100'; var pre = new Image(); var went = false; var go = function () { if (went || my !== token) return; went = true; img.style.transition = 'opacity .18s ease'; img.style.opacity = '0'; setTimeout(function () { if (my !== token) return; img.removeAttribute('srcset'); img.src = src; var shown = false; var show = function () { if (shown) return; shown = true; img.style.opacity = '1'; }; if (img.complete) show(); else img.addEventListener('load', show, { once: true }); setTimeout(show, 400); }, 180); }; pre.onload = go; pre.onerror = go; pre.src = src; if (pre.complete) go(); }); } function prefetch() { var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (m && document.querySelector('variant-selects')) images(m[1]).then(function (list) { list.forEach(function (u) { var i = new Image(); i.src = u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=1100'; }); }); } document.addEventListener('change', function (e) { var t = e.target; var vs = t && t.closest && t.closest('variant-selects'); if (!vs) return; var groups = Array.prototype.slice.call(vs.querySelectorAll('fieldset, .product-form__input')); lastIdx = groups.findIndex(function (g) { return g.contains(t); }); last = t.value; if (lastIdx > 0) swap(); setTimeout(swap, 1200); }, true); if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.variantChange, function () { swap(); }); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefetch); else prefetch(); })();